<div class="container">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise-fade" [fullScreen]="true"><p style="color: white"> Loading... </p></ngx-spinner>
  <div class="wrapper">
    <form *ngIf="mode=='Login'" #f="ngForm" novalidate class="form-signin">
      <img style="width: 100%; margin: 5px;" src="assets/home_logo.png" />

      <input type="text" required name="username" class="form-control" placeholder="User Name" ngModel>
      <input type="password" class="form-control" id="password" required name="password" placeholder="Password" ngModel>
      <div id="lower">
        <button class="btn btn-lg btn-primary btn-block col-12" [disabled]="f.invalid || isRequesting" (click)="login(f)">Login</button>
        <!--<input type="submit" value="Login" [disabled]="f.invalid || isRequesting">-->
        <p class="center">or</p>
        <button class="btn btn-lg btn-primary btn-block col-12" (click)="ssoLogin()">Connect via SSO</button>
      </div>
      <div *ngIf="errors" class="alert alert-danger" role="alert">
        {{errors}}
      </div>
      <br>
      <div>
        <div class="controls" style="text-align: center;">
          <a id="resetLink" [routerLink]="['/forgot-password']">Forgot Password</a>
        </div>
      </div>
    </form>
    <!-- Change password required -->
    <form *ngIf="mode=='ChangePassword'" [formGroup]="changef" class="form-signin">
      <img style="width: 100%; margin: 5px;" src="assets/home_logo.png" />
      <p class="center">Change Password Required</p>

      <input type="password" class="form-control" id="password" required name="password" formControlName="password" placeholder="New Password" ngModel>
      <div *ngIf="changef.controls.password.invalid && (changef.controls.password.dirty || changef.controls.password.touched)"
           class="form-control-feedback" style="color:red;">
        <p *ngIf="changef.controls.password.errors.required">
          Password is required.
        </p>
        <p *ngIf="changef.controls.password.errors.minlength">
          Password must be at least 8 characters long.
        </p>
        <p *ngIf="changef.controls.password.errors.pattern">
          Password must have at least one uppercase and one lowercase character, one number and one special character &#40; &#94;$ * . [ ] &#123; &#125; &#40; &#41; ? &quot; ! &#64; # % &amp; / \ , &gt; &lt; ' : ; | _ ~ `&#41;
        </p>
      </div>
      <input type="password" class="form-control" id="confirmpassword" required name="confirmpassword" formControlName="confirmpassword" placeholder="Confirm Password" ngModel>
      <div *ngIf="(changef.controls.confirmpassword.errors || changef.errors?.mismatch) && (changef.controls.confirmpassword.dirty || changef.controls.confirmpassword.touched)"
           class="form-control-feedback">
        <span *ngIf="changef.controls.confirmpassword.errors || changef.errors?.mismatch" style="color: red;">
          Passwords must match
        </span>
      </div>
      <div id="lower">
        <button class="btn btn-lg btn-primary btn-block col-12" [disabled]="!changef.valid || isRequesting" (click)="changePassword(changef)">Change Password</button>
      </div>
      <div *ngIf="errors" class="alert alert-danger" role="alert">
        {{errors}}
      </div>
    </form>

    <!-- Setup MFA required -->
    <form *ngIf="mode=='MFASetup'" #mfasetupf="ngForm" novalidate class="form-signin">
      <img style="width: 100%; margin: 5px;" src="assets/home_logo.png" />
      <p class="center">MFA Setup Required</p>

      <qrcode class="center" [qrdata]="mfaqrcode" [width]="250" errorCorrectionLevel="M"></qrcode>
      <p class="center">Scan this QR code with Google Authenticator or Authy.</p>

      <input type="text" class="form-control" id="mfa" required name="mfa" placeholder="MFA Code" ngModel>
      <br />
      <div id="lower">
        <button class="btn btn-lg btn-primary btn-block col-12" [disabled]="mfasetupf.invalid || isRequesting" (click)="mfaSetup(mfasetupf)">Submit MFA Code</button>
      </div>
      <div *ngIf="errors" class="alert alert-danger" role="alert">
        {{errors}}
      </div>
    </form>

    <!-- MFA Request Code -->
    <form *ngIf="mode=='MFA'" #mfaf="ngForm" novalidate class="form-signin">
      <img style="width: 100%; margin: 5px;" src="assets/home_logo.png" />
      <p class="center">MFA Code Required</p>

      <input type="text" class="form-control" id="mfa" required name="mfa" placeholder="MFA Code" ngModel>
      <br />
      <div id="lower">
        <button class="btn btn-lg btn-primary btn-block col-12" [disabled]="mfaf.invalid || isRequesting" (click)="mfaCode(mfaf)">Submit MFA Code</button>
      </div>
      <div *ngIf="errors" class="alert alert-danger" role="alert">
        {{errors}}
      </div>
    </form>
  </div>
</div>
